"use client";

import styles from "@/styles/global/expedite-dialog.module.scss";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Dialog from "@/components/global/Dialog";
import type { ExpediteData, ExpediteItem } from "@/types/global";

export default function ExpediteDialog() {
  const [visible, setVisible] = useState(false);
  const [expediteData, setExpediteData] = useState<ExpediteData | null>(
    null
  );
  const router = useRouter();

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("expeditData");
      if (raw) {
        let parsed: ExpediteData | null = null;
        try {
          parsed = JSON.parse(raw);
        } catch {
          parsed = { message: String(raw) };
        }
        setExpediteData(parsed);
        setVisible(true);
      }
    } catch {
    }
  }, []);

  if (!visible) return null;

  const items: ExpediteItem[] = Array.isArray(expediteData?.items) ? expediteData!.items! : [];
  const totalQuantity = items.reduce((sum: number, item) => {
    const qty = Number(item?.quantity) || 0;
    return sum + qty;
  }, 0);

  const visibleItems = items.slice(0, 3);
  const totalAmount = (() => {
    const num = Number(expediteData?.total);
    return Number.isFinite(num) ? num : 0;
  })();

  return (
    <Dialog
      visible={visible}
      title="You have an unpaid order"
      className={styles["expedite-dialog"]}
      titleClassName={styles["expedite-title"]}
      actionClassName={styles["expedite-actions"]}
      cancelButtonClassName={styles["expedite-cancel-button"]}
      confirmButtonClassName={styles["expedite-confirm-button"]}
      closeable={true}
      showConfirmButton={true}
      showCancelButton={true}
      confirmButtonText="PAY NOW"
      cancelButtonText="IGNORE"
      onClose={() => {
        setVisible(false);
      }}
      onCancel={() => {
        sessionStorage.removeItem("expeditData");
        setVisible(false);
      }}
      onConfirm={() => {
        setVisible(false);
        const oid = expediteData?.orderID;
        if (oid) {
          router.push(`/my-account/order-details/${oid}`)
        }
      }}
    >
      <div className={styles["expedite-dialog-content"]}>
        <div className={styles["expedite-num"]}>
          {totalQuantity} items are waiting for payment:
        </div>

        <div className={styles["expedite-list"]}>
          {visibleItems.map((item, index) => {
            const src = item?.defaultNewThumbnailUrl || item?.defaultFullUrl;
            if (!src) return null;
            return (
              <div key={item?.productID || index} className={styles["expedite-image-wrap"]}>
                <Image
                  width={60}
                  height={60}
                  src={src}
                  alt={String(item?.name || "product")}
                  className={styles["expedite-image"]}
                />
                <span className={styles["expedite-qty-badge"]}>X{Number(item?.quantity) || 0}</span>
              </div>
            );
          })}
          {items.length > 3 ? (
            <div className={styles["expedite-more"]}
            onClick={() => {
              setVisible(false);
              const oid = expediteData?.orderID;
              if (oid) {
                router.push(`/my-account/order-details/${oid}`)
              }
            }}>more</div>
          ) : null}
        </div>

        <div className={styles["expedite-total-box"]}>
          <div className={styles["expedite-total-title"]}>Pay only:</div>
          <div className={styles["expedite-total-num"]}>${totalAmount.toFixed(2)}</div>
        </div>
      </div>
    </Dialog>
  );
}
